'use client';

import React, { useState, useEffect } from 'react';
import { FileText } from 'lucide-react';

export default function ComplianceReportsHeader() {
  const [dateStr, setDateStr] = useState('');

  useEffect(() => {
    setDateStr(
      new Date()?.toLocaleDateString('en-IN', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    );
  }, []);

  return (
    <div className="flex items-center justify-between px-5 py-4 border-b border-border bg-card">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center">
          <FileText size={18} className="text-primary" />
        </div>
        <div>
          <h1 className="text-base font-bold text-foreground leading-tight">Compliance Reports</h1>
          <p className="text-xs text-muted-foreground">{dateStr || 'Loading…'}</p>
        </div>
      </div>
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-primary/10 border border-primary/20">
        <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
        <span className="text-xs font-medium text-primary">Regulatory Mode</span>
      </div>
    </div>
  );
}
